import { AiKnowledgeBaseToolTip } from 'src/pages/AIKnowledgeBasePage/AiKnowledgeBaseToolTip';
import { EditKnowledgeBaseItemModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/edit/EditKnowledgeBaseItemModal/EditKnowledgeBaseItemModal';
import { MoveKnowledgeBaseItemModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/MoveKnowledgeBaseItemModal/MoveKnowledgeBaseItemModal';
import { DeleteKnowledgeBaseItemModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/delete/DeleteKnowledgeBaseItemModal/DeleteKnowledgeBaseItemModal';
import { CheckboxKnowledgeBasePage } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseTableList/CheckboxKnowledgeBase';
import { TableCell } from 'src/components/ui/table';
import React from 'react';
import { EditItemIcon } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseIcons/CurrentKnowledgeBaseIcons';
import { useKBContext } from 'src/provider/KnowledgeBaseProvider';

export const ActionCellFiles = ({
  item,
  handleSingleItemMove,
  handleSingleItemEdit,
  handleSingleItemDelete,
  is,
  checked,
  onChange,
}) => {
  const { setIsEditPopupOpen, setSelectedItem } = useKBContext();
  return (
    <TableCell
      padding={'p-5'}
      className="max-w-80 !rounded-none !border-r-0 [&:has([role=checkbox])]:pr-5"
    >
      <div
        className="flex items-center justify-end gap-7.5"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onDoubleClick={(e) => {
          e.stopPropagation();
        }}
      >
        <AiKnowledgeBaseToolTip
          side={'top'}
          trigger={
            <div>
              {is.md || is.faq || is.txt ? (
                <button
                  className={'flex gap-2 opacity-30 hover:opacity-100 transition'}
                  onClick={() => {
                    if (is.deleting || is.uploading) {
                      return;
                    }

                    setSelectedItem(item);
                    setIsEditPopupOpen(true);
                  }}
                >
                  <EditItemIcon />
                </button>
              ) : (
                <EditKnowledgeBaseItemModal
                  handleSingleItemEdit={handleSingleItemEdit}
                  item={item}
                />
              )}
            </div>
          }
          content={<span className={'text-xs opacity-50 text-ebony'}>Edit</span>}
        />
        <AiKnowledgeBaseToolTip
          side={'top'}
          trigger={
            <div>
              <MoveKnowledgeBaseItemModal handleMoveFiles={handleSingleItemMove} item={item} />
            </div>
          }
          content={<span className={'text-xs opacity-50 text-ebony'}>Move</span>}
        />
        <AiKnowledgeBaseToolTip
          side={'top'}
          trigger={
            <div>
              <DeleteKnowledgeBaseItemModal
                handleSingleItemDelete={handleSingleItemDelete}
                item={item}
              />
            </div>
          }
          content={<span className={'text-xs opacity-50 text-ebony'}>Delete</span>}
        />
        {(is.delete || is.move) && (
          <CheckboxKnowledgeBasePage checked={checked} item={item} onChange={onChange} />
        )}
      </div>
    </TableCell>
  );
};
